import { Trans, useTranslation } from '@frontend/i18n';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { theme } from '@frontend/theme';
import { Button, ButtonBar, Modal, ModalControlModalProps, Text } from '@frontend/design-system';

type Props = {
  modalProps: ModalControlModalProps;
};

export const LearnMoreModal = ({ modalProps }: Props) => {
  const { t } = useTranslation('bulk-messaging');
  const { navigate: settingsNavigate } = useSettingsNavigate();

  return (
    <Modal {...modalProps} minWidth={600}>
      <Modal.Header onClose={modalProps.onClose}>
        <Text
          css={{
            fontSize: theme.fontSize(24),
          }}
        >
          {t('Why Link Business Email?')}
        </Text>
      </Modal.Header>
      <Modal.Body css={{ paddingTop: theme.spacing(2) }}>
        <Text
          css={{
            marginBottom: theme.spacing(2),
          }}
        >
          {t(
            'With your subscription, you can send campaigns from any of your business-related emails. The benefits of using your business email instead of Weave’s email:'
          )}
        </Text>
        <ul
          css={{
            marginBottom: theme.spacing(2),
          }}
        >
          <Trans t={t}>
            <li
              css={{
                marginBottom: theme.spacing(1),
              }}
            >
              <strong>Improved Deliverability</strong>: Emails sent from your domain are less likely to be marked as
              spam, leading to higher deliverability rates and better engagement.
            </li>
          </Trans>
          <Trans t={t}>
            <li>
              <strong>Brand Consistency</strong>: Emails coming from your domain are going to appear more consistent
              with your branding which will benefit your brand recognition and trust.
            </li>
          </Trans>
        </ul>
        <Text>
          {t(
            'The number of messages you are able to send from your account may require you to link your business email.'
          )}
        </Text>
        <ButtonBar>
          <Button variant='secondary' name='closeButton' onClick={modalProps.onClose}>
            {t('Close')}
          </Button>
          <Button
            variant='primary'
            name='linkButton'
            onClick={() => {
              settingsNavigate({
                to: '/email',
              });
              modalProps.onClose();
            }}
          >
            {t('Link Now')}
          </Button>
        </ButtonBar>
      </Modal.Body>
    </Modal>
  );
};
